import GroupingSelector from './GroupingSelector'
import _ from 'underscore'

export default function GroupingSelectorWithDetailsLevel()
{
    this.constructor = GroupingSelectorWithDetailsLevel;
}

GroupingSelectorWithDetailsLevel.prototype = _.create(GroupingSelector.prototype);

/**
 * Initializes selector
 * @param selectorId
 * @param numberOfLevels - a number of grouping levels (details level must not be counted), 3 levels max
 * @param initialValues - an array containing initial values
 * @param changesCallback
 */
GroupingSelectorWithDetailsLevel.prototype.init = function(selectorId, numberOfLevels, initialValues, changesCallback)
{
    GroupingSelector.prototype.init.call(this, selectorId, numberOfLevels, initialValues, changesCallback);

    this.updateDetailsOptions();
};

GroupingSelectorWithDetailsLevel.prototype.initListSelectors = function(numberOfLevels, initialValues, changesCallback)
{
    GroupingSelector.prototype.initListSelectors.call(this, numberOfLevels, initialValues, changesCallback);

    const self = this;
    this.detailsListSelector = this.initListSelector( numberOfLevels, initialValues[numberOfLevels],
                                                      function()
                                                      {
                                                          self.onDetailsChange();
                                                          if (changesCallback)
                                                              changesCallback();
                                                      }
    );
};

GroupingSelectorWithDetailsLevel.prototype.onGroupingChange = function()
{
    this.updateDetailsOptions();
    GroupingSelector.prototype.onGroupingChange.call(this);
};

GroupingSelectorWithDetailsLevel.prototype.onDetailsChange = function()
{
    this.updateTree();
};

GroupingSelectorWithDetailsLevel.prototype.getDetailsListSelectorValue = function()
{
    return this.detailsListSelector.getSelectedItem().value;
};

GroupingSelectorWithDetailsLevel.prototype.updateDetailsOptions = function()
{
    // do nothing
};

GroupingSelectorWithDetailsLevel.prototype.getValues = function()
{
    const selection = GroupingSelector.prototype.getValues.call(this);
    selection.push(this.getDetailsListSelectorValue());
    return selection;
};

GroupingSelectorWithDetailsLevel.prototype.setValues = function(values)
{
    const valuesCopy = values.slice();
    const detailsValue = valuesCopy.pop();
    GroupingSelector.prototype.setValues.call(this, valuesCopy);
    this.detailsListSelector.setActiveItemByValue(detailsValue);
};



// WEBPACK FOOTER //
// ./web/js/reports/GroupingSelectorWithDetailsLevel.js